import { getCookie, setCookie } from './utils'

export const LAST_LOGIN_METHOD_COOKIE = 'crateLastLoginMethod'

const supportedLoginMethods = new Set(['email', 'google', 'apple', 'facebook'])

export const getLastLoginMethod = () => {
  const method = getCookie(LAST_LOGIN_METHOD_COOKIE)

  return supportedLoginMethods.has(method) ? method : null
}

export const setLastLoginMethod = (method) => {
  if (!supportedLoginMethods.has(method)) {
    return
  }

  setCookie(LAST_LOGIN_METHOD_COOKIE, method, 365)
}
